import type {ReactNode} from 'react'
import styled, {css} from 'styled-components'
import type {SpaceProps} from 'styled-system'
import {space} from 'styled-system'

import {tokens} from '@pleo-io/telescope'

import {pxBreakpoints} from 'styles/theme'
import {containerQuery, useContainerQuery} from '~/generic-ui/container-queries/container'

export const useSplitContentMediaQuery = () =>
    useContainerQuery({maxWidth: pxBreakpoints.desktopMedUp})

const Content = styled.div<SpaceProps & {reverse?: boolean}>`
    display: flex;
    flex-direction: ${({reverse}) => (reverse ? 'column-reverse' : 'column')};
    ${containerQuery(
        {minWidth: pxBreakpoints.desktopMedUp},
        css`
            flex-direction: row;
        `,
    )}
    ${space}
`
const Main = styled.div`
    flex: 3;
    margin-bottom: ${tokens.spacing40};
    ${containerQuery(
        {minWidth: pxBreakpoints.desktopMedUp},
        css`
            margin-bottom: 0;
            margin-right: ${tokens.spacing20};
        `,
    )}
`
const Right = styled.div`
    flex: 2;
    margin-bottom: ${tokens.spacing40};
    display: flex;
    flex-direction: column;
    ${containerQuery(
        {minWidth: pxBreakpoints.desktopMedUp},
        css`
            margin-bottom: 0;
            margin-left: ${tokens.spacing20};
        `,
    )}
`
const Sticky = styled.div`
    position: initial;
    ${containerQuery(
        {minWidth: pxBreakpoints.desktopMedUp},
        css`
            position: sticky;
            z-index: ${tokens.zIndexNavigation};
            top: ${tokens.spacing20};
            margin-bottom: ${tokens.spacing24};
        `,
    )}
`

interface SplitContentProps extends SpaceProps {
    reverse?: boolean
    children: ReactNode
}

export const SplitContent = (props: SplitContentProps) => <Content {...props} />

SplitContent.Main = Main
SplitContent.Right = Right
SplitContent.Sticky = Sticky
